module.exports = __webpack_public_path__ + "static/media/blog_canimolt_15nov_amarillo__.0b95e135.png";